import { Nomenclature } from './Nomenclature';

export class StatusBean extends Nomenclature {

	deklaracijaChlen83?: boolean;
	zavedenaPretencija?: boolean;
	plashtaneDarjavnaTaksa?: boolean;
	statusReshen?: boolean;
	zadacha?: boolean;

}
  